import axios from 'axios';
import { configs } from '../app/app-configs';
import {
    Sale,
    SaleRequest,
    SaleSearchCriteria,
    SaleSummary,
} from './model/store.model';
import { PaginatedResponse } from './model/paginated-response';

export const getSaleSummary = async (): Promise<SaleSummary> => {
    return await axios.get(`${configs.BASE_URL}/sales/summary`).then((res) => {
        return res.data as SaleSummary;
    });
};

export const getSales = async (
    search: SaleSearchCriteria
): Promise<PaginatedResponse<Sale>> => {
    return await axios
        .get(
            `${configs.BASE_URL}/sales?page=${search.pagination.page}&size=${search.pagination.size}&from=${search.from}&to=${search.to}&name=${search.name}`
        )
        .then((res) => {
            return res.data;
        });
};

export const createSale = async (request: SaleRequest): Promise<Sale> => {
    return await axios
        .post(`${configs.BASE_URL}/sales`, request)
        .then((res) => {
            return res.data as Sale;
        });
};

export const updateSale = async (request: SaleRequest): Promise<Sale> => {
    return await axios
        .put(`${configs.BASE_URL}/sales/${request.id}`, request)
        .then((res) => {
            return res.data as Sale;
        });
};

export const deleteSale = async (id: number): Promise<number> => {
    return await axios.delete(`${configs.BASE_URL}/sales/${id}`).then((res) => {
        return res.data;
    });
};
